import { PageHeader } from "@/components/common/Loader";
import { PasswordChangeCard } from "@/components/common/Forms";
import { useAuth } from "@/context/AuthContext";

export default function AdminAccount() {
  const { user, logout } = useAuth();
  return (
    <div className="max-w-2xl space-y-8">
      <PageHeader eyebrow="Il mio account" title={user.name} subtitle={`${user.email} · ${user.role === "superadmin" ? "Super Admin" : "Admin"}`} />
      <PasswordChangeCard />
      <button data-testid="admin-account-logout-btn" onClick={logout} className="btn-link">Esci dall'account</button>
    </div>
  );
}
